module.exports = __webpack_public_path__ + "static/imgs/map-bg41.094b722.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/map-bg41.png
// module id = ugbM
// module chunks = 1